import toastr from 'toastr';
import { userAtom } from '../atoms/userAtom';
import { settingsAtom } from '../atoms/settingsAtom';
import { getRecoil, setRecoil } from 'recoil-nexus';
import loginService from '../services/loginServices';
import constStatusResponse from '../commons/constStatusResponse';

const apiUtils = {};
const GetConfig = async () => {
  const settings = { ...getRecoil(settingsAtom) };
  if (settings.apiUrl) return settings;
  const res = await fetch('../../appsettings.json');
  let data;
  try {
    data = await res.json();
    const newSettings = {
      apiUrl: data.apiUrl,
      appName: data.appName
    };
    setRecoil(settingsAtom, newSettings);
  } catch (e) {
    console.log('error:', e);
  }
  return data;
};

apiUtils.getConfig = GetConfig;

apiUtils.checkStatus = response => {
  if ((response.status >= constStatusResponse.ok && response.status < constStatusResponse.multipleChoices)) {
    return response;
  } else if (response.status === constStatusResponse.forbidden) {
    return apiUtils.Unauthorized();
  } else {
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
};

apiUtils.getFetchParameters = (method, body, removeAuth) => {
  const user = getRecoil(userAtom);
  const param = {
    method,
    headers: { 'Content-Type': 'application/json' }
  };

  if (!removeAuth) {
    param.headers.Authorization = 'Bearer ' + user.accessInfo.accessToken;
  }
  if (body) {
    param.body = JSON.stringify(body);
  }

  return param;
};

apiUtils.exec = async (endpoint, params) => {
  var internalParams = params || apiUtils.getFetchParameters('GET');
  const config = await GetConfig();
  const url = config.apiUrl + endpoint;

  return await fetch(url, internalParams)
    .then(res => {
      if (res.status >= constStatusResponse.ok && res.status < constStatusResponse.multipleChoices || res.status === constStatusResponse.tooManyRequests) {
        return res.json();
      } else if (res.status === constStatusResponse.unauthorized) {
        // eslint-disable-next-line no-console
        console.log('API returned 401');
        loginService.quit();
        // Force iterruption of promise
        return Promise.reject();
      } else if (res.status === constStatusResponse.forbidden) {
        return apiUtils.Unauthorized();
      } else if (res.status === constStatusResponse.payloadTooLarge) {
        return res;
      }
    }).catch((err) => {
      // eslint-disable-next-line no-console
      console.log('Error: ', err);
      loginService.quit();
      return Promise.reject(err);
    });
};

apiUtils.isActive = () => {
  const user = getRecoil(userAtom);
  return user.accessInfo.accessToken !== null;
};

apiUtils.execAsync = async (endpoint, params) => {
  var internalParams = params || apiUtils.getFetchParameters('GET');
  const config = await GetConfig();
  const url = config.apiUrl + endpoint;

  const res = await fetch(url, internalParams);

  if (res && res.status === constStatusResponse.forbidden) {
    return apiUtils.Unauthorized();
  }

  return res.json();
};

apiUtils.Unauthorized = () => {
  const user = getRecoil(userAtom);
  const newUser = { ...user, hasRouteAccess: false };
  setRecoil(userAtom, newUser);
  toastr.error('Usuário não tem acesso a essa funcionalidade.');
};

export default apiUtils;
